import dynamic from 'next/dynamic';
export const SvgIcon = dynamic(() => import('./Icon/SvgIcon'));
export default SvgIcon;
export const AcCharge = dynamic(() => import('./Icon/AcCharge'));
export const CarCharge = dynamic(() => import('./Icon/CarCharge'));
export const PsCharge = dynamic(() => import('./Icon/PsCharge'));
export const SolarCharge = dynamic(() => import('./Icon/SolarCharge'));
export const ModeEco = dynamic(() => import('./Icon/ModeEco'));
export const ModeSleep = dynamic(() => import('./Icon/ModeSleep'));
export const Icon360 = dynamic(() => import('./Icon/Icon360'));
export const R290 = dynamic(() => import('./Icon/R290'));
export const Upto = dynamic(() => import('./Icon/UpTo2'));
export const Upto1 = dynamic(() => import('./Icon/UpTo'));
export const TopTip = dynamic(() => import('./Icon/TopTip2'));
// export const TopTip2 = dynamic(() => import('./Icon/TopTip2'));
